import { Facebook, Instagram, MessageCircle } from "lucide-react";

import { cn } from "@/lib/utils";

import { CHANNEL_LABEL, type ChatChannel } from "./social";

const ICONS = {
  whatsapp: { icon: MessageCircle, className: "bg-emerald-500" },
  instagram: { icon: Instagram, className: "bg-pink-500" },
  messenger: { icon: Facebook, className: "bg-blue-600" },
} as const;

/** Small round badge with the channel of a conversation. */
export const ChannelIcon = ({
  channel,
  className,
}: {
  channel: ChatChannel;
  className?: string;
}) => {
  const { icon: Icon, className: color } = ICONS[channel];
  return (
    <span
      title={CHANNEL_LABEL[channel]}
      className={cn(
        "inline-flex h-4 w-4 items-center justify-center rounded-full text-white",
        color,
        className,
      )}
    >
      <Icon className="h-2.5 w-2.5" />
    </span>
  );
};
